// C:\Ava_Local\Ava_API\avaai_dashboard\frontend\src\pages\education\DivisionPage.tsx
import React from "react";
import TutorPage from "./TutorPage";

export default function DivisionPage() {
  return <TutorPage initialTopic="Division" lockTopic />;
}